import { filetypeValidator } from '@/utils/shared'
import { CUSTOM_OPTION_TYPE } from '@/config/config'

export default () => {
  return {
    cmd: {
      type: String,
      required: true
    },

    fileType: {
      validator: filetypeValidator,
      required: true
    },

    toFileType: {
      type: String,
      required: true
    },

    targetTypes: {
      type: Array,
      required: true
    },

    customOptionType: { // CUSTOM_OPTION_TYPE
      type: String,
      default: CUSTOM_OPTION_TYPE.NORMAL
    },

    covertTitle: {
      type: String,
      required: true
    }
  }
}
